import * as Sentry from '@sentry/vue'
import { inject } from '@vercel/analytics'
import { createApp } from 'vue'
import { SnackbarService } from 'vue3-snackbar'
import 'vue3-snackbar/styles'
import App from './App.vue'
import './assets/css/base.css'
import './assets/css/main.css'
import router from './router'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://5659a366ed1802e70b5b28283e86f907@o4509433356156928.ingest.de.sentry.io/4509433359433808',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0
})

app.use(SnackbarService)
app.use(router)
app.mount('#app')

inject()
